import React, { useEffect, useState } from "react";
import Search from "../../../assets/Search.svg";
import "./FindMemorial.css";
import { Link } from "react-router-dom";
import { getBackendUrl, parseJsonSafe } from "../../../utils/memorialApi";

const FindMemorial = () => {
  const [memorials, setMemorials] = useState([]);
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);

  useEffect(() => {
    const trimmed = query.trim();
    if (!trimmed) {
      setMemorials([]);
      setSearched(false);
      setLoading(false);
      return;
    }

    setLoading(true);
    const timeout = setTimeout(() => {
      fetch(`${getBackendUrl()}/api/memorials?search=${encodeURIComponent(trimmed)}`)
        .then(async (res) => {
          const data = await parseJsonSafe(res);
          return data || { memorials: [] };
        })
        .then((data) => {
          setMemorials(data.memorials || []);
          setSearched(true);
          setLoading(false);
        })
        .catch(() => {
          setMemorials([]);
          setSearched(true);
          setLoading(false);
        });
    }, 400);

    return () => clearTimeout(timeout);
  }, [query]);

  return (
    <div className="grid-container">
      <p className="intro-text">find a memorial</p>
      <div className="grid-row">
        <div className="input-container">
          <input
            type="text"
            placeholder="Search by name..."
            className="full-width"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            aria-label="Search memorials by name"
          />
          <img src={Search} alt="" />
        </div>
      </div>
      {loading && <p className="search-status">Searching...</p>}
      {!loading && searched && memorials.length === 0 && query.trim() && (
        <p className="search-status">No public memorials found. Try another name.</p>
      )}
      {memorials.length > 0 && (
        <ul className="search-results" role="listbox" aria-label="Memorial search results">
          {memorials.map((memorial) => {
            const slug = memorial.slug || `${memorial.firstName}${memorial.lastName}`;
            const label = `${memorial.firstName || ""} ${memorial.lastName || ""}`.trim();
            const subtitle = memorial.webAddress || memorial.slug || "";
            return (
              <li key={memorial._id} role="option">
                <Link
                  to={`/profile/${slug}/${memorial._id}`}
                  className="search-result-link"
                >
                  <span className="search-result-text">
                    <span className="search-result-name">{label || subtitle}</span>
                    {label && subtitle && (
                      <span className="search-result-slug">{subtitle}</span>
                    )}
                  </span>
                  <span className="search-result-arrow" aria-hidden="true">
                    ›
                  </span>
                </Link>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default FindMemorial;
